import { 
    MDBContainer,
    MDBCard,
    MDBCardBody,
    MDBCardTitle,
    MDBCardText,
    MDBBtn,
    MDBInput
 } from "mdb-react-ui-kit";
import React from "react";
import Swal from "sweetalert2";
const Settings = () => {
    const changepassword = (e) => {
        e.preventDefault()
        const {oldPassword, newPassword} = e.target
        fetch(`${process.env.REACT_APP_URL}user/changepass`,{
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                username: 'superadmin',
                oldPassword: oldPassword.value,
                newPassword: newPassword.value
            })
        }).then(result => result.json())
        .then(data =>{
            if(data.message === "success"){
                Swal.fire({
                    title: "Password Change Successfully",
                    icon: "success",
                    text: `Password has been change`
                  }).then(result => {
                    if(result.isConfirmed){
                        window.location.href = '/dashboard/admin'
                    }
                    
                  })
            } else {
                Swal.fire({
                    title: "Change Password Failed",
                    icon: "info",
                    text: "Please Check your password"
                })
            }
        })
    }
    return(
    <MDBContainer className="d-flex justify-content-center align-items-center min-vh-100">
    <MDBCard className="bg-primary text-white">
    <form onSubmit={changepassword}>
      <MDBCardBody>
        <MDBCardTitle>Change Password</MDBCardTitle>
        <MDBCardText>Old Password</MDBCardText>
        <MDBInput type="password" name="oldPassword">

        </MDBInput>
        <MDBCardText>New Password</MDBCardText>
        <MDBInput type="password" name="newPassword">
            
        </MDBInput>
        <MDBBtn type="submit" className="bg-success mt-3">Submit</MDBBtn>
      </MDBCardBody>
      </form>
    </MDBCard>
    </MDBContainer>
    )
    
}

export default Settings;